var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ia-cliente-contatos" },
    [
      _c(
        _vm.navegavel ? "button" : "div",
        {
          tag: "component",
          staticClass: "ia-cliente-contatos__rotulo ia-texto-selo",
          attrs: { type: _vm.navegavel ? "button" : null },
          on: { click: _vm.aoClicar }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.rotulo))]),
          _vm.navegavel
            ? _c("icon-svg", {
                attrs: {
                  name: "arrow-left",
                  size: _vm.TAMANHO_CHEVRON,
                  color: "var(--neutral-600)"
                }
              })
            : _vm._e(),
          !_vm.carregando
            ? _c(
                "span",
                {
                  staticClass: "ia-sidebar-contador ml-auto",
                  attrs: { "data-test": "ia-cliente-contatos-contador" }
                },
                [_vm._v(" " + _vm._s(_vm.contador) + " ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.carregando
        ? _c(
            "ul",
            { staticClass: "ia-cliente-contatos__lista" },
            _vm._l(_vm.LINHAS_PENDENTES, function(linha) {
              return _c("li", { key: linha.chave }, [
                _c("span", { staticClass: "ia-cliente-contatos__marcador" }),
                _c(
                  "span",
                  { staticClass: "ia-cliente-contatos__texto" },
                  [
                    _c(
                      "BaseLoadingSkeleton",
                      _vm._b({}, "BaseLoadingSkeleton", _vm.CAIXA_DATA, false)
                    ),
                    _c(
                      "BaseLoadingSkeleton",
                      _vm._b({}, "BaseLoadingSkeleton", _vm.CAIXA_RESUMO, false)
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        : _vm.vazio
        ? _c(
            "p",
            { staticClass: "ia-cliente-contatos__vazio ia-texto-auxiliar" },
            [_vm._v(" Nenhum contato registrado ")]
          )
        : _c(
            "ul",
            { staticClass: "ia-cliente-contatos__lista" },
            _vm._l(_vm.contatos, function(contato) {
              return _c("li", { key: contato.chave }, [
                _c("span", {
                  staticClass: "ia-cliente-contatos__marcador",
                  class: {
                    "ia-cliente-contatos__marcador--recente": contato.recente
                  }
                }),
                _c("span", { staticClass: "ia-cliente-contatos__texto" }, [
                  _c(
                    "span",
                    {
                      staticClass: "ia-cliente-contatos__data ia-texto-auxiliar"
                    },
                    [_vm._v(_vm._s(contato.data))]
                  ),
                  contato.resumo
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "ia-cliente-contatos__resumo ia-texto-corpo"
                        },
                        [_vm._v(" " + _vm._s(contato.resumo) + " ")]
                      )
                    : _vm._e()
                ])
              ])
            }),
            0
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }